const base = {
    black: '#000000',
    white: '#FFFFFF'
}

export default base
